export const propertyCondition = [
  { rus: "Новое жильё", en: "New property", hebrew: "נכס חדש" },
  { rus: "После ремонта", en: "Renovated", hebrew: "משופץ" },
  { rus: "Хорошее состояние", en: "Good condition", hebrew: "במצב טוב" },
  { rus: "Требует ремонта", en: "Needs renovation", hebrew: "דורש שיפוץ" },
  { rus: "Строящееся", en: "Under construction", hebrew: "בתהליך בנייה" },
];